<template>
  <div class="h-full bg-base-200 dark:bg-neutral overflow-y-auto scrollbar-thin">


    <!-- Guest Navigation -->
    <div class="px-3 py-4">
      <ul class="menu menu-sm w-full rounded-box">
        <li class="menu-title text-xs font-medium opacity-70">Navigation</li>
        <li>
          <router-link to="/" class="flex items-center rounded-lg py-2 group" :class="{'active': route.path === '/'}">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 mr-3 group-hover:text-primary transition-colors">
              <path stroke-linecap="round" stroke-linejoin="round" d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
            </svg>
            Home
          </router-link>
        </li>
        <li>
          <router-link to="/features" class="flex items-center rounded-lg py-2 group">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 mr-3 group-hover:text-primary transition-colors">
              <path stroke-linecap="round" stroke-linejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
            </svg>
            Features
          </router-link>
        </li>
        <li>
          <router-link to="/pricing" class="flex items-center rounded-lg py-2 group">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 mr-3 group-hover:text-primary transition-colors">
              <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z" />
            </svg>
            Pricing
          </router-link>
        </li>

        <div class="divider my-2"></div>
        
        <!-- Authentication -->
        <li class="menu-title text-xs font-medium opacity-70">Account</li>
        <li>
          <router-link to="/users/login" class="flex items-center rounded-lg py-2 group" :class="{'active': route.path.includes('/users/login')}">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 mr-3 group-hover:text-primary transition-colors">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15M12 9l-3 3m0 0 3 3m-3-3h12.75" />
            </svg>
            Log In
            <span class="badge badge-primary badge-sm ml-auto">New</span>
          </router-link>
        </li>
        <li>
          <router-link to="/users/signIn" class="flex items-center rounded-lg py-2 group" :class="{'active': route.path.includes('/users/signIn')}">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 mr-3 group-hover:text-primary transition-colors">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0ZM4 19.235v-.11a6.375 6.375 0 0 1 12.75 0v.109A12.318 12.318 0 0 1 10.374 21c-2.331 0-4.512-.645-6.374-1.766Z" />
            </svg>
            Sign Up
          </router-link>
        </li>

        <div class="divider my-2"></div>
        
        <!-- Legal -->
        <li class="menu-title text-xs font-medium opacity-70">Legal</li>
        <li>
          <router-link to="/tos" class="flex items-center rounded-lg py-2 group" :class="{'active': route.path === '/tos'}">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 mr-3 group-hover:text-primary transition-colors">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
            </svg>
            Terms of Service
          </router-link>
        </li>
        <li>
          <router-link to="/privacy" class="flex items-center rounded-lg py-2 group" :class="{'active': route.path === '/privacy'}">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 mr-3 group-hover:text-primary transition-colors">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z" />
            </svg>
            Privacy Policy
          </router-link>
        </li>
      </ul>
    </div>

    <!-- Bottom Actions -->
    <div class="mt-auto px-3 py-4 border-t border-base-300 dark:border-neutral-focus">
      <div class="space-y-4">
        <div class="bg-primary/10 rounded-lg p-4">
          <h3 class="font-medium text-primary mb-2">Join Our Community</h3>
          <p class="text-sm opacity-80 mb-3">Get access to all features and join thousands of users.</p>
          <router-link to="/users/signIn" class="btn btn-primary btn-sm w-full">
            Sign up for free
          </router-link>
        </div>
        
        <div class="flex flex-col gap-2">
          <button class="btn btn-sm btn-ghost flex items-center gap-2 w-full">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z" />
            </svg>
            Help & Support
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const urlArr = ref([
  {
    to: "/",
    title: "Home Page",
  },
  {
    to: "/users/login",
    title: "Log In",
  },
  {
    to: "/users/signIn",
    title: "Sign Up",
  },
  {
    to: "/tos",
    title: "Terms of Service",
  },
  {
    to: "/privacy",
    title: "Privacy Policy",
  },
]);
</script>

<style scoped>
.scrollbar-thin {
  scrollbar-width: thin;
}
</style>